export const SET_SLUGS_TO_EXPORT_HISTORIC = 'SET_SLUGS_TO_EXPORT_HISTORIC';
export const SET_INITIAL_DATE = 'SET_INITIAL_DATE';
export const SET_FINAL_DATE = 'SET_FINAL_DATE';
export const SET_REMOVE_STANBDY = 'SET_REMOVE_STANBDY';
export const SET_FORMATATION_FILE = 'SET_FORMATATION_FILE';
export const SET_FILE_TYPE = 'SET_FILE_TYPE';
